/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";
import React, {Fragment} from "react";
import {service as SurveyService} from "../../../Services/SurveyService";
import {ObjectUtils} from "../../../Utils";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";

export class SurveyValidator extends BaseValidator {
    constructor () {
        super();

        this.duplicated = null;
        this.lastSearch = {};
    }

    name(model) {
        return this.message(model);
    }

    async logic(model, data) {
        const {
            surveyId,
            organizationId,
            surveyTypeId,
            conservationActionTypeId,
            SurveyPrograms:assignedPrograms = [],
        } = data;

        const relevantFields = {surveyId, surveyTypeId, conservationActionTypeId, organizationId, assignedPrograms};

        // don't check for duplicates unless one of the relevant fields changed
        // unfortunately there is no way to prevent this from happening at least
        // once because when the validator is initialized we don't have a reference
        // to the "data" structure. (see GenericModelViewerBase.validate() which
        // calls this.props.Model.recordValidators)
        if(!ObjectUtils.Compare(relevantFields, this.lastSearch)) {

            const {
                SurveyPrograms:assignedPrograms = [],
            } = data;
            
            const { result, error } = await SurveyService.GetSurveys(surveyTypeId, conservationActionTypeId, null);
            if (error) {
                console.error(error);
                return true;
            }

            this.duplicated = result.find(existingSurvey => {
                
                // TODO: keep testing this logic
                
                if(surveyId === existingSurvey.surveyId) {
                    return false;
                }
                
                // if they are both Default or Organization surveys
                if (assignedPrograms?.length === 0 && existingSurvey?.SurveyPrograms?.length === 0) {
                    // if both organizationIds are null these are conflicting Default surveys
                    // or if both organizationIds are the same these are conflicting Organization surveys
                    // otherwise, they are non-conflicting Default or Organization surveys
                    return existingSurvey?.organizationId === organizationId;
                }
                
                // if they are both Program surveys
                else if(assignedPrograms?.length > 0 && existingSurvey?.SurveyPrograms?.length > 0) {
                    // and the existing survey already has one of the assigned programs
                    // then they are conflicting Program surveys
                    return existingSurvey?.SurveyPrograms?.find(
                        surveyProgram => (
                            assignedPrograms.find(assignedProgram => assignedProgram.programId === surveyProgram.programId)
                        )
                    );
                }
                
                // otherwise one is a Program survey and the other is a Default or Organization survey
                // which means they do not conflict, Program takes precedence, followed by Organization, then Default
                return false;
            });

            this.lastSearch = relevantFields;
        }

        return this.duplicated == null;
    }

    message(model, data) {
        const combinationType = !!data?.SurveyPrograms?.length ? 'Program' : 'Organization';

        return <Fragment>
            <div>This Survey Type, Conservation Action Type, and {combinationType} combination conflicts with the existing survey:</div>
            <StreamBankLink
                className="link-primary survey-conflict-link"
                Href={`/surveys/${this?.duplicated?.surveyId}`}
            >{SurveyService.GetTitle(this.duplicated)}</StreamBankLink>
        </Fragment>;
    }
}
